import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class WhitelabelRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    async getWhitelabelByApiKey(apiKey) {
        return axios.get(`${this.basePath}/whitelabel/by-api-key/${apiKey}`);
    }

    async updateUserProForwhitelabel(partnerId) {
        let headers = { 'Authorization': store.state.token };
        let response = axios.get(`${this.basePath}/whitelabel/partner/${partnerId}/pro-upgrade`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

}

export default new WhitelabelRepository();
